"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionToggle = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _TypeGuards = require("../Utility/TypeGuards");

var _Config = require("../Utility/Config");

var _Alert = require("../Utility/Alert");

var VersionToggle = function VersionToggle(props) {
  var _props$item$newStatus;

  var contentApi = (0, _react.useRef)();
  var assetsApi = (0, _react.useRef)();
  var historyApi = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showingPublished = _useState2[0],
      setShowingPublished = _useState2[1];

  var lastVersion = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var loadVersion = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!showingPublished) {
                _context2.next = 4;
                break;
              }

              setShowingPublished(false);
              props.onVersionLoaded(props.item);
              return _context2.abrupt("return");

            case 4:
              if (lastVersion.current) {
                _context2.next = 12;
                break;
              }

              setLoading(true);
              _context2.next = 8;
              return (0, _Alert.alertOnError)("Failed to load previous version", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                var history, createdDraftVersion, lastPublishedVersion, _props$schema, content;

                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        historyApi.current = new _sdk.HistoryApi(props.config);
                        _context.next = 3;
                        return historyApi.current.getHistory(props.config.appName, (0, _TypeGuards.isAsset)(props.item) ? "assets.".concat(props.item.id) : "contents.".concat(props.item.id));

                      case 3:
                        history = _context.sent;
                        createdDraftVersion = history.findIndex(function (w) {
                          return w.eventType === "ContentDraftCreatedEvent" || w.eventType === "AssetDraftCreatedEvent";
                        }); // Last published version is the version right before creating draft, so it is next in the history.

                        lastPublishedVersion = history[createdDraftVersion + 1].version;

                        if (!(0, _TypeGuards.isAsset)(props.item)) {
                          _context.next = 15;
                          break;
                        }

                        if (props.item.id) {
                          _context.next = 9;
                          break;
                        }

                        throw new Error("Item is missing ID");

                      case 9:
                        assetsApi.current = new _sdk.AssetsApi((0, _Config.includeFlow)(props.config));
                        _context.next = 12;
                        return assetsApi.current.getAsset(props.config.appName, props.item.id, lastPublishedVersion);

                      case 12:
                        lastVersion.current = _context.sent;
                        _context.next = 26;
                        break;

                      case 15:
                        content = props.item;

                        if (content.id) {
                          _context.next = 18;
                          break;
                        }

                        throw new Error("Item is missing ID");

                      case 18:
                        if ((_props$schema = props.schema) !== null && _props$schema !== void 0 && _props$schema.name) {
                          _context.next = 20;
                          break;
                        }

                        throw new Error("Item is missing schema name");

                      case 20:
                        if (lastPublishedVersion) {
                          _context.next = 22;
                          break;
                        }

                        throw new Error("Item is missing version");

                      case 22:
                        contentApi.current = new _sdk.ContentsApi((0, _Config.includeFlow)(props.config));
                        _context.next = 25;
                        return contentApi.current.getContentVersion(props.config.appName, props.schema.name, content.id, lastPublishedVersion);

                      case 25:
                        lastVersion.current = _context.sent;

                      case 26:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 8:
              success = _context2.sent;
              setLoading(false);

              if (success) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return");

            case 12:
              setShowingPublished(true);
              if (lastVersion.current) props.onVersionLoaded(lastVersion.current);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function loadVersion() {
      return _ref.apply(this, arguments);
    };
  }();

  if (!props.item || !props.item.newStatus) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "formtype prmbl-versionToggle",
    style: {
      padding: ".5rem .65rem",
      background: "rgba(255,255,255,.5)",
      display: "flex",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#b0c0d0",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "prmbl-versionToggle-title",
    style: {
      flexGrow: "1",
      margin: 0
    }
  }, showingPublished ? "Published" : "".concat((_props$item$newStatus = props.item.newStatus) !== null && _props$item$newStatus !== void 0 ? _props$item$newStatus : props.item.status)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: loading,
    id: "view-published-button",
    className: "prmbl-versionToggle-switchButton",
    onClick: loadVersion
  }, loading ? "Loading..." : showingPublished ? "View New Version" : "View Current Version"));
};

exports.VersionToggle = VersionToggle;